import { Box } from "@mui/material";
import { DateField } from "components/Forms/DateField";
import { FormSelect } from "components/Forms/FormSelect";
import { RadioGroupField } from "components/Forms/RadioGroupField";
import { RcraLqgClosureType } from "generated-graphql/graphql";
import { useValidatingFormContext } from "hooks/useValidatingForm";
import { useFormContext } from "react-hook-form";
import { selectItemsFromLabels } from "routes/Customer/Facility/ProfileV2/rcraProfileLabels";

import { CLOSURE_TYPE_LABELS } from "../../rcraNotificationLabels";
import { DATE_PICKER_PROPS, gridSx, YES_NO_OPTIONS } from "./constants";
import { SectionHeader } from "./SectionHeader";
import { FilingNotificationsFormData } from "./types";

/** §15 LQG Site Closure. */
export function LqgSiteClosureSection() {
  const { control } = useValidatingFormContext<FilingNotificationsFormData>();
  const { watch } = useFormContext<FilingNotificationsFormData>();
  const gate = watch("closureGate");
  const requestingNew = watch("requestingNewClosureDateGate");

  return (
    <Box sx={gridSx}>
      <Box sx={{ gridColumn: "span 12" }}>
        <SectionHeader label="LQG Site Closure (§15)" />
      </Box>
      <Box sx={{ gridColumn: "span 12" }}>
        <RadioGroupField
          label="Are you notifying of an LQG site closure?"
          name="closureGate"
          control={control}
          radioOptions={YES_NO_OPTIONS}
        />
      </Box>
      {gate === true && (
        <>
          <Box sx={{ gridColumn: { xs: "span 12", sm: "span 6" } }}>
            <FormSelect
              label="Closure type"
              name="closureType"
              control={control}
              selectItems={selectItemsFromLabels<RcraLqgClosureType>(CLOSURE_TYPE_LABELS).map(
                ({ value, display }) => ({ value, display })
              )}
            />
          </Box>
          <Box sx={{ gridColumn: { xs: "span 12", sm: "span 6" } }}>
            <DateField
              label="Expected closure date"
              name="expectedClosureDate"
              control={control}
              datePickerProps={DATE_PICKER_PROPS}
            />
          </Box>
          <Box sx={{ gridColumn: "span 12" }}>
            <RadioGroupField
              label="Are you requesting a new closure date?"
              name="requestingNewClosureDateGate"
              control={control}
              radioOptions={YES_NO_OPTIONS}
            />
          </Box>
          {requestingNew === true && (
            <Box sx={{ gridColumn: { xs: "span 12", sm: "span 6" } }}>
              <DateField
                label="Requested new closure date"
                name="requestingNewClosureDate"
                control={control}
                datePickerProps={DATE_PICKER_PROPS}
              />
            </Box>
          )}
          <Box sx={{ gridColumn: { xs: "span 12", sm: "span 6" } }}>
            <DateField
              label="Actual closure date"
              name="actualClosureDate"
              control={control}
              datePickerProps={DATE_PICKER_PROPS}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
